<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, defineExpose } from "vue";
import { useRouter } from 'vue-router'
import mypageRecordService from "../../../services/mypage/mypageRecordService";
import adminUserService from "../../../../admin/services/user/adminUserService";
import mypageProposalService from "../../../services/mypage/mypageProposalService";
import Loading from 'vue3-loading-overlay';
import MyPageResumeModalBody from "../mypage/MyPageResumeModalBody.vue";
import {useMyPageLectDetailStore} from "../../../stores/mypage/mypageLectDetailStore";
import mypageUserResumeService from "../../../services/mypage/mypageUserResumeService";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import { useAlertStore } from "../../../../../stores/alertStore";
import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";
import AlertCustomModal from "@/pages/user/components/modal/jobFair/AlertCustomModal.vue";
import MyPageApplyCompanyListModal from "@/pages/user/components/modal/mypage/MyPageApplyCompanyListModal.vue";

const { $confirm, $alert } = useAlertStore();

const router = useRouter();
const loadingStore = usePageLoadingStore()
const lectureStore = useMyPageLectDetailStore()

const viewSources = ref('');
const baseModal = ref(null);
const resolvePromise = ref(null);

const modalBody = ref(null);
const alertCustomModal = ref(null);
const modalContent = ref([]);
const applyCompanyListModal = ref(null);

const loaded = ref(false)

const showButtons = ref(false)
const showPropButtons = ref(false)
const resumeLikeTxts = ref("♡관심인재");
const disabledCorpYns = ref(false);
const resumeLikeYns = ref(0)
const resumeIds = ref(0)
const lectIds = ref(0)
const regDts = ref(0)
const corpIds = ref(0);

const mode = ref("mypage")

const recordCopy = ref({})
const interests = ref("")

// 마이페이지 이력서 보기
// userId가 있으면 해당인원, 없으면 로그인한 계정
const retrieveRecordDetail = (userId) => {
  loaded.value = false;
  mode.value = "mypage";
  
  // 기업홍보관에서 호출된 경우 lectIds와 regDts 초기화
  // if (viewSources.value === 'promotion') {
  //   lectIds.value = 0;
  //   regDts.value = 0;
  // }
  lectIds.value = 0;
  regDts.value = 0;
  
  if(userId) {
    let paramObj = {
      userId: userId,
      propId: 0,
      hidden: 0,
    }
    adminUserService.retrieveUserMyPage(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setHidden(0);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    mypageRecordService.retrieveRecord()
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setHidden(0);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  }
}

// 기업 마스터쪽에서 이력서 조회. hidden 1
// userId가 있으면 해당인원, 없으면 로그인한 계정
const retrieveMatchingRecordDetail = (userId, propId) => {
  loaded.value = false;
  mode.value = "mypage";
  if(userId !== undefined && propId !== undefined) {
    let paramObj = {
      userId: userId,
      propId: propId,
      hidden: 1,
    }
    adminUserService.retrieveUserMyPage(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setHidden(1);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    console.log('USER ID가 없습니다.')
  }
}

// 수강신청이력서 보기
const retrieveUserLectureRecordDetail = (userId, lectId, regDt) => {
  loaded.value = false;

  lectIds.value = lectId;
  regDts.value = regDt;

  mode.value = "userLecture";
  const lecture = {
    "userId" : userId,
    "lectId" : lectId,
    "regDt" : regDt
  }
  lectureStore.setLecture(lecture)

  if(userId && lectId && regDt) {
    adminUserService.retrieveUserLectureMypage(userId, lectId, regDt)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    $toast('', '새로고침 후 다시 실행해주세요.');
  }
}


// 강의 신청 이력서 보기 - 기업홍보관
const retrieveUserLectureRecord = (userId, lectId, regDt, corpId) => {
  lectIds.value = lectId;
  regDts.value = regDt;
  corpIds.value = corpId;
  loaded.value = false;
  const lecture = {
    "userId" : userId,
    "lectId" : lectId,
    "regDt" : regDt
  }

  lectureStore.setLecture(lecture)
  if(userId && lectId && regDt) {
    mypageCorpInfoService.retrieveUserLectureRecord(userId, lectId, regDt)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    $toast('', '새로고침 후 다시 실행해주세요.');
  }
}

// 입사지원이력서 보기
const retrieveUserMatchingResumeDetail = (resumeId, hidden) => {
  loaded.value = false;
  resumeIds.value = resumeId;

  if(resumeId) {
    let paramObj = {
      resumeId: resumeId,
      hidden: hidden,
    }
    mypageUserResumeService.retrieveMatchingResume(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setHidden(hidden);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    $toast('', '새로고침 후 다시 실행해주세요');
  }
}


// 입사지원이력서 보기 - 기업홍보관
const retrieveApplicantResume = (resumeId, hidden) => {
  loaded.value = false;

  if(resumeId) {
    mypageCorpInfoService.retrieveApplicantResume(resumeId, hidden)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setHidden(hidden);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    $toast('', '새로고침 후 다시 실행해주세요');
  }
}

// 이력서 보기 - 상시채용관
const retrieveUserMatchingJobResumeDetail = (resumeId, hidden) => {
  loaded.value = false;
  resumeIds.value = resumeId;

  if(resumeId) {
    let paramObj = {
      resumeId: resumeId,
      hidden: hidden,
    }
    mypageUserResumeService.retrieveApplicantResume(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setHidden(hidden);
            modalBody.value.setRecord(result);
            recordCopy.value = result;
            interests.value = result.interests
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {
    $toast('', '새로고침 후 다시 실행해주세요');
  }
}

// 이력관리 이력서 수정
const onClickChangeRecord = () => {
  router.push({ name: 'MyPageRecord', query : { mode: viewSources.value, corpId: corpIds.value } })
}

// 기업 홍보관 입사지원
const onClickApplicant = async (lectId, regDt) => {
  // 강의 이력서로 입사지원 시
  const ok = await $confirm(["해당 기업에 ‘입사지원’을 하시겠습니까?", "입사지원한 이력서는 수정할 수 없습니다."], "입사지원", "아니오");
  if(!ok) {
    return -1;
  } else {
    const paramObj = {
      corpId: corpIds.value,
      userId: recordCopy.value.userId,
    }
    
    // 강의 이력서인 경우 lectId와 regDt 추가
    if (lectId) {
      paramObj.lectId = lectId;
    }
    if (regDt) {
      paramObj.regDt = regDt;
    }

    loadingStore.loading = true;
    mypageCorpInfoService.createApplicant(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            // const result = res.data.result;
            await alertCustomModal.value.show();

            baseModal.value.close();
            resolvePromise.value(false);

          }
        }).catch( async (error) =>  {
      loadingStore.loading = false;
      // console.log(error);
      const ok = await $confirm(["이력서의 필수 항목 정보가 없습니다.", "이력서를 확인하고 입사지원을 다시 진행해주세요."], "이력서 확인하기")
      if(!ok) {
        return -1;
      } else {
        // 이력관리
        onClickChangeRecord();
      }
    });
  }
}

// 이력서 수정 버튼. 새창으로 열기
const onClickChangeResume = () => {
  router.push({ name: 'UserMatchingResume', query : { mode: mode.value }})
}

// 인재정보 공개 버튼. 완료 후 입사지원현황 페이지로 이동
const onClickSendResume = () => {
  if (interests.value === null || interests.value === "") {
    $alert("관심 카테고리를 선택하지 않았습니다. [이력서 수정]버튼을 눌러 관심 카테고리를 선택하세요.");
  } else {
    confirmSendResume();
  }
}

// 인재정보 공개
const confirmSendResume = async () => {
  const ok = await $confirm(["이력서를 <인재정보>로 공개할까요?", "공개된 이력서는 기업들만 확인이 가능하며, 공개 이후", "언제든 ‘공개/비공개’ 설정이 가능합니다."], "인재정보 공개", "취소");
  if ( ok ) { // 전송
    loaded.value = false;
    mypageUserResumeService.createResumeRecord ( recordCopy.value )
        .then(async (res) => {
          loaded.value = true;

          await $alert("이력서가 <인재정보>로 공개되었습니다.");

          if(res.data.code.toLowerCase() === 'success') {
            baseModal.value.close();
            if (resolvePromise.value) {
              resolvePromise.value(false);
            }
            await router.push({ name:'UserMatchingJob', query: { tab: 'userResume' } });
            router.go(0);
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  } else {    // 취소

  }
}

// 입사지원 기업 선택
const onClickApplyCompany = () => {
  applyCompanyListModal.value.init(lectIds.value, regDts.value);
  applyCompanyListModal.value.show();
}

// 채용 제안
const onClickResumeCorpYn = async (resumeId) => {
  const ok = await $confirm(["지원자에게 채용을 제안할까요?", "제안을 하면 지원자는 채용을 수락하거나 거절할 수 있습니다."], "채용 제안", "취소");
  if(!ok) {
    return -1;
  } else {
    let paramObj2 = {
      resumeId: resumeId,
    }
    mypageProposalService.createResumeCorporationByResumeId(paramObj2)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            $alert("채용을 제안하였습니다.");
            disabledCorpYns.value = true;
            //$toast('', "채용을 제안하였습니다.")
          } else {
            $alert("제안을 실패하였습니다.");
            console.log(res);
          }
        }).catch( (res) =>  {
          loadingStore.loading = false;
          $alert("제안을 실패하였습니다.");
        });
  }
}

// 관심 인재
const onClickResumeLikeYn = async (resumeId, yn) => {
  let ok;
  if(yn === 1) {
    ok = await $confirm(["관심인재를 삭제하시겠습니까?"], "관심인재 삭제", "취소");
  } else {
    ok = await $confirm(["관심인재를 등록하시겠습니까?"], "관심인재 등록", "취소");
  }
  if(!ok) {
    return -1;
  } else {
    let paramObj3 = {
      resumeId: resumeId,
      likeState: yn,
    }
    mypageProposalService.changeResumeLikeByResumeId(paramObj3)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            $alert("변경하였습니다.");
            if(yn === 1) {
              resumeLikeTxts.value = "♡관심인재";
              resumeLikeYns.value = 0;
            } else {
              resumeLikeTxts.value = "♥관심인재";
              resumeLikeYns.value = 1;
            }
            //$toast('', msg+"을(를) 하였습니다.")
          } else {
            $alert("변경을 실패하였습니다.");
          }
        }).catch( (res) =>  {
          loadingStore.loading = false;
          $alert("변경을 실패하였습니다.");
        }); 
  }
}

const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = async () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

const init = (showButton, showPropButton, resumeCorpYn, resumeLikeYn, viewSource, corpId = 0) => {
  // 기본값 저장
  //input.value.lectId = lectId;
  showButtons.value = showButton;
  showPropButtons.value = showPropButton;
  viewSources.value = viewSource;
  if (corpId) {
    corpIds.value = corpId;
  }
  if (resumeLikeYn === 1) {
    resumeLikeTxts.value = "♥관심인재";
  } else {
    resumeLikeTxts.value = "♡관심인재";
  }

  if (resumeCorpYn === 1) {
    disabledCorpYns.value = true;
  } else {
    disabledCorpYns.value = false;
  }
  resumeLikeYns.value = resumeLikeYn;
}

defineExpose({
  show,
  init,
  retrieveRecordDetail,
  retrieveMatchingRecordDetail,
  retrieveUserLectureRecordDetail,
  retrieveUserMatchingResumeDetail,
  retrieveUserLectureRecord,
  retrieveApplicantResume,
  retrieveUserMatchingJobResumeDetail,
})
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <loading
        :active="!loaded"
        loader="dots"
        color="#3843AF"
        opacity="0.5"
        width="35"
        :is-full-page="false"></loading>
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body" v-show="loaded">
        <MyPageResumeModalBody ref="modalBody"/>
      </div>
      <div v-if="showButtons" class="modal-footer btn-wrap">
        <span data-title="이력서 수정 : ">
          <KSASecondaryButton text="이력서 수정" @click="onClickChangeResume" />
        </span>
        <span data-title="인재정보 공개 : ">
          <KSAPrimaryButton text="입사지원 기업 선택" @click="onClickApplyCompany" class="mr-xs" />
          <KSAPrimaryButton text="인재정보 공개" @click="onClickSendResume" />
        </span>
      </div>
      <div v-if="showPropButtons" class="modal-footer btn-wrap">
        <span data-title="관심 인재 : ">
          <KSASecondaryButton :text="resumeLikeTxts" @click="onClickResumeLikeYn(resumeIds, resumeLikeYns)" class="red_button"/>
        </span>
        <span data-title="채용 제안 : ">
          <KSAPrimaryButton text="채용 제안" :disabled="disabledCorpYns" @click="onClickResumeCorpYn(resumeIds)" />
        </span>
      </div>
      <div v-if="viewSources === 'promotion'" class="modal-footer btn-wrap">
        <KSASecondaryButton text="이력서 수정" @click="onClickChangeRecord" />
        <KSAPrimaryButton text="입사지원" @click="onClickApplicant(lectIds, regDts)" style="margin-left: auto;" />
      </div>
    </div>
  </Modal>
  <AlertCustomModal ref="alertCustomModal" :content="modalContent" /> <!-- 커스텀 팝업: 입사지원 완료 -->
  <MyPageApplyCompanyListModal ref="applyCompanyListModal" />
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>
